<template>
  <v-layout row wrap>
    <v-app-bar
      flat
    >
      <v-img
        src="/img/logo-grey-2x.png"
      />
    </v-app-bar>
  </v-layout>
</template>

<script>
// import { mapActions } from 'vuex'
// import TodoItem from '@/components/TodoItem.vue'
// import FooterInfo from '@/components/FooterInfo.vue'

// const filters = {
//   all: todos => todos,
//   active: todos => todos.filter(todo => !todo.done),
//   completed: todos => todos.filter(todo => todo.done)
// }

export default {
  // props: ['filter'],
  // components: {
  //   TodoItem,
  //   FooterInfo
  // },
  data () {
    return {
      // newTodo: '',
      // filters: filters,
      // visibility: this.filter
    }
  },
  computed: {
    // todos () {
    //   return this.$store.state.todos
    // },
    // allChecked () {
    //   return this.todos.every(todo => todo.done)
    // },
    // filteredTodos () {
    //   return filters[this.visibility](this.todos)
    // },
    // remaining () {
    //   return this.todos.filter(todo => !todo.done).length
    // },
    // progressPercentage () {
    //   const len = this.todos.length
    //   return ((len - this.remaining) * 100) / len
    // }
  },
  methods: {
    // ...mapActions([
    //   'toggleAll',
    //   'clearCompleted'
    // ]),
    // addTodo () {
    //   const text = this.newTodo.trim()
    //   if (text) {
    //     this.$store.dispatch('addTodo', text)
    //   }
    //   this.newTodo = ''
    // }
  },
  filters: {
    // pluralize: (n, w) => n === 1 ? w : (w + 's'),
    // capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
  }
}
</script>
